<template>

	<v-dialog
			@keydown.esc="closeDialog"
			max-width="1000px"
			persistent
			v-model="$store.getters.instructionsDialog">
		<v-card min-height="650px" class="gradient-border-card d-flex flex-column">
			<v-card-title class="headline white--text" style="background: #11254d;background: linear-gradient(90deg,rgba(17, 37, 77, 1) 0%, rgba(17, 113, 112, 1) 50%, rgba(21, 168, 147, 1) 100%);">
				Οδηγίες χρήσης
				<v-spacer/>
				<v-btn
						color="white"
						icon
						@click="closeDialog"
				><v-icon large>close</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text>
				<h3>Απλή Αναζήτηση</h3>
				<br/>

				<p>Χρησιμοποιώντας την απλή αναζήτηση, μπορείτε να αναζητήσετε ακριβείς όρους (ανεξαρτήτως τονισμού ή κεφαλαίων χαρακτήρων)
					σε οποιοδήποτε πεδίο του βιβλίου, ή να κάνετε μερική ταύτιση, χρησιμοποιώντας το χαρακτήρα *.
					<br/><br/>
					Τοποθετώντας το χαρακτήρα *,
					στην αρχή, το τέλος ή στο ενδιάμεσο μιας ακολουθίας χαρακτήρων μπορείτε να αναζητήσετε όλα τα αποτελέσματα που αρχίζουν,
					τελειώνουν, εμπεριέχουν ή εμπεριέχονται από αυτή την ακολουθία, πχ. η αναζήτηση: μαθη*, επιστρέφει ως αποτέλεσμα όλες τις
					εγγραφές που περιέχουν κάποια λέξη που αρχίζει από μαθη, όπως μάθημα, μαθήματα, μαθηματικά, μαθητική, μάθηΜΑΤΙΚΑ κλπ.
					Αντίστοιχα χρησιμοποιώντας το χαρακτήρα και στην αρχή και στο τέλος μιας ακολουθίας χαρακτήρων μπορείτε να αναζητήσετε
					όλα τα αποτελέσματα που περιέχουν τις συγκεκριμένες ακολουθίες, πχ η αναζήτηση *εργ*, επιτρέφει ως αποτέλεσμα: κατεργασία,
					ενέργεια, εργαζόμενοι, συνεργατισμός, εργαστήριο κλπ.
				</p>

				<br/><br/>
				<h3>Σύνθετη Αναζήτηση</h3>
				<br/>
				<p>
					Στη σύνθετη αναζήτηση μπορείτε να αναζητήσετε ακριβείς όρους σε ένα συγκεκριμένο πεδίο του βιβλίου ή να κάνετε μερική ταύτιση,
					χρησιμοποιώντας το χαρακτήρα *. Ο χαρακτήρας * δεν μπορεί να χρησιμοποιηθεί για αναζήτηση στα πεδία 'Κωδικός Βιβλίου', 'ISBN'
					και 'Έτος Τρέχουσας Έκδοσης'.
					<br/><br/>
					Τέλος, μπορείτε να επιλέξετε συγκεκριμένο εκδότη (διαθέτη) με ή χωρίς πρόσθετα κριτήρια αναζήτησης.
				</p>

				<br/>
				<p>
					<strong>Σημείωση:</strong> Στη σύνθετη αναζήτηση, η αναζήτηση στο πεδίο <strong>ISBN</strong> μπορεί να γίνει <strong>είτε με τον ISBN-10</strong>
					<br/>
					<strong>είτε με τον ISBN-13.</strong> Αντίθετα στην απλή αναζήτηση, η αναζήτηση γίνεται ακριβώς με τον ISBN που δόθηκε στο πεδίο αναζήτησης.
				</p>

			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "InstructionsDialog",

		methods: {
			closeDialog() {
				this.$store.commit('setInstructionsDialog', false);
			},
		}
	}
</script>

<style scoped>
	/*.gradient-border-card {*/
	/*	border: 4px solid transparent; !* Controls the thickness *!*/
	/*	border-image: linear-gradient(*/
	/*			90deg,*/
	/*			rgba(17, 37, 77, 1) 0%,*/
	/*			rgba(17, 113, 112, 1) 50%,*/
	/*			rgba(21, 168, 147, 1) 100%*/
	/*	);*/
	/*	border-image-slice: 1;*/
	/*}*/
	.gradient-border-card {
		border: 4px solid transparent;
		border-image: linear-gradient(
				90deg,
				rgba(17, 37, 77, 1) 0%,
				rgba(17, 113, 112, 1) 50%,
				rgba(21, 168, 147, 1) 100%
		);
		border-image-slice: 1;
		border-radius: 0!important;
	}



</style>